module.exports = __webpack_public_path__ + "static/media/roma-placuta.3486b7be.png";